import {useEffect, useRef, useState} from "react";

export function useEventQueue(processBatch) {
    const queueRef = useRef([]);
    const processingRef = useRef(false);
    const [, forceRender] = useState({});

    const addEvents = (event) => {
        if (!event || event.length === 0) return;
        queueRef.current.push(event);
        forceRender({});
    };

    const processQueue = async () => {
        if (processingRef.current) return;
        processingRef.current = true;

        while (queueRef.current.length > 0) {
            const batch = queueRef.current.shift();
            await processBatch(batch);
        }

        processingRef.current = false;
    };

    useEffect(() => {
        if (queueRef.current.length > 0) {
            processQueue();
        }
    });

    return {
        addEvents,
        pendingBatches: queueRef.current.length,
        isProcessing: processingRef.current,
    };
}
